import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({name: 'dateFormat'})
export class DateFormatPipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');

  transform(value: any, format: string = 'dd/MM/yyyy'): string {
    if(!value) return '';
    const formatted = this.datePipe.transform(value, format);
    return formatted ? `${formatted} (${format.toLowerCase()})` : '';
  }
}
